import * as React from 'react';

import classnames from 'classnames';

import {Button} from '../../button/button';
import {colors} from '../../colors/colors';
import {ChevronDownIcon} from '../../icon';

import styles from './more-options-button.module.css';

type Props = {
    onPrimaryClick: () => void;
    onSecondaryClick: () => void;
    isDisabled: boolean;
    primaryText: string;
    primaryIcon?: any;
    getButtonRef?: any;
    size?: 'small' | 'big';
    variant?: 'primary' | 'secondary';
};

export function MoreOptionsButton(props: Props) {
    const {size = 'big', variant = 'primary'} = props;
    const styleNames = classnames(
        {
            [styles['more-options-button']]: true,
        },
        variant,
        size
    );

    return (
        <div className='flex'>
            <Button
                variant={variant}
                size={size}
                onClick={() => props.onPrimaryClick()}
                getButtonRef={props.getButtonRef}
                disabled={props.isDisabled}
                style={{borderTopRightRadius: 0, borderBottomRightRadius: 0}}
            >
                {props.primaryIcon ? (
                    <div className='flex align-center gap-8'>
                        <props.primaryIcon size={14} style={{display: 'flex'}} />
                        {props.primaryText}
                    </div>
                ) : (
                    props.primaryText
                )}
            </Button>
            <button
                disabled={props.isDisabled}
                onClick={props.onSecondaryClick}
                className={styleNames}
            >
                <ChevronDownIcon
                    size={size === 'big' ? 11 : 10}
                    // @ts-expect-error
                    fill={colors.white}
                    style={{marginTop: '-2px'}}
                />
            </button>
        </div>
    );
}
